module.exports = __webpack_public_path__ + "static/media/pago.40d841c6.svg";